import { mainviewActions, appActions, MAPBOX_ROOT_URL } from '../helpers/constants';

const initialState = {
  latitude: -27.471,
  longitude: 153.036,
  mapStyle: `${ MAPBOX_ROOT_URL }streets-v11`,
  maxBounds: [
    [109.239510, -44.762161], // Southwest coordinates (lon, lat)
    [158.084117, -8.986036] // Northeast coordinates
  ],
  zoom: [2],
  pitch: [0],
  bearing: [0],

  selectedAddress: {},
  showSearchMarker: false,

  isGeolocated: false,
  userGeoPosition: {},

  showKoalaPopup: false,
  koalaPopupData: null,

  showBoundaryPopup: false,
  boundaryCoords: null,
  federalBoundaryPopupData: null,
  stateBoundaryPopupData: null,
  lgaBoundaryPopupData: null,

  showSightingLayer: false,
  showFederalLayer: false,
  showLGALayer: false,
  showStateLayer: false,
  showPropertyLayer: false,

  showNVISHabitat: false,
  showKHAHabitat: false,
  showPreClearingHabitat: false,

  addedKoalaId: null,

  adminSightingListData: null,
  
  userKoalaSightingListData: null,
  editedKoalaSighting: null,

  userAccountListData: null,
  editedUserAccount: null,

  isChoosingLocation: false,
  chosenLocation: null
}

const reducer = (state = initialState, action) => {

  const { payload, type } = action;

  switch (type) {
    case mainviewActions.GEOLOCATE_USER_SUCCESS:
      return {
        ...state,
        latitude: payload.lat,
        longitude: payload.lon,
        zoom: [10],
        isGeolocated: true,
        userGeoPosition: {
          latitude: payload.lat,
          longitude: payload.lon,
        }
      }
    case mainviewActions.GEOLOCATE_USER_ERROR:
      return {
        ...state,
        ...payload
      }
    case mainviewActions.RESET_MAP_VIEW:
      return {
        ...state,
        zoom: [2],
        pitch: [0],
        bearing: [0],
        latitude: -26.358,
        longitude: 144.660
      }
    case mainviewActions.SEARCH_ADDRESS_SELECTED:
      return {
        ...state,
        selectedAddress: payload,
        latitude: payload.center[1],
        longitude: payload.center[0],
        showSearchMarker: true,
        zoom: [14]
      }
    case mainviewActions.HIDE_SEARCH_MARKER:
      return {
        ...state,
        showSearchMarker: false
      }
    case mainviewActions.SET_MAP_LAYER_TYPE:
      return {
        ...state,
        mapStyle: payload
      }
    case mainviewActions.SHOW_KOALA_GEOJSON:
    case mainviewActions.HIDE_KOALA_GEOJSON:
      return {
        ...state,
        showSightingLayer: payload
      }
    case mainviewActions.SHOW_FEDERAL_GEOJSON:
    case mainviewActions.HIDE_FEDERAL_GEOJSON:
      return {
        ...state,
        showFederalLayer: payload
      }
    case mainviewActions.SHOW_LGA_GEOJSON:
    case mainviewActions.HIDE_LGA_GEOJSON:
      return {
        ...state,
        showLGALayer: payload
      }
    case mainviewActions.SHOW_STATE_GEOJSON:
    case mainviewActions.HIDE_STATE_GEOJSON:
      return {
        ...state,
        showStateLayer: payload
      }
    case mainviewActions.SHOW_PROPERTY_LAYER:
    case mainviewActions.HIDE_PROPERTY_LAYER:
      return {
        ...state,
        showPropertyLayer: payload
      }
    case mainviewActions.SHOW_KHA_LAYER:
    case mainviewActions.HIDE_KHA_LAYER:
      return {
        ...state,
        showKHAHabitat: payload,
        showPreClearingHabitat: false,
        showNVISHabitat: false
      }
    case mainviewActions.SHOW_NVIS_LAYER:
    case mainviewActions.HIDE_NVIS_LAYER:
      return {
        ...state,
        showNVISHabitat: payload,
        showKHAHabitat: false,
        showPreClearingHabitat: false
      }
    case mainviewActions.SHOW_PRECLEARING_LAYER:
    case mainviewActions.HIDE_PRECLEARING_LAYER:
      return {
        ...state,
        showPreClearingHabitat: payload,
        showKHAHabitat: false,
        showNVISHabitat: false
      }
    case mainviewActions.SHOW_KOALA_POPUP:
    case mainviewActions.HIDE_KOALA_POPUP:
      return {
        ...state,
        showKoalaPopup: payload.show,
        koalaPopupData: payload.data
      }
    case mainviewActions.SHOW_BOUNDARY_POPUP:
    case mainviewActions.HIDE_BOUNDARY_POPUP:
      return {
        ...state,
        showBoundaryPopup: payload.show,
        boundaryCoords: payload.coords
      }
    case mainviewActions.GET_FEDERAL_BOUNDARY_DATA:
      return {
        ...state,
        federalBoundaryPopupData: payload
      }
    case mainviewActions.REMOVE_FEDERAL_BOUNDARY_DATA:
      return {
        ...state,
        federalBoundaryPopupData: null
      }
    case mainviewActions.GET_STATE_BOUNDARY_DATA:
      return {
        ...state,
        stateBoundaryPopupData: payload
      }
    case mainviewActions.REMOVE_STATE_BOUNDARY_DATA:
      return {
        ...state,
        stateBoundaryPopupData: null
      }
    case mainviewActions.GET_LGA_BOUNDARY_DATA:
      return {
        ...state,
        lgaBoundaryPopupData: payload
      }
    case mainviewActions.REMOVE_LGA_BOUNDARY_DATA:
      return {
        ...state,
        lgaBoundaryPopupData: null
      }
    case mainviewActions.GET_ALL_KOALA_SIGHTINGS:
      return {
        ...state,
        adminSightingListData: payload
      }
    case mainviewActions.GET_KOALA_SIGHTINGS_BY_USER:
      return {
        ...state,
        userKoalaSightingListData: payload
      }
    case mainviewActions.EDIT_KOALA_SIGHTING: // Moving map to edited koalas location also
      return {
        ...state,
        editedKoalaSighting: payload,
        latitude: payload.latitude,
        longitude: payload.longitude,
        zoom: [16]
      }
    case mainviewActions.EDIT_KOALA_SIGHTING_SUCCESS:
      return {
        ...state,
        editedKoalaSighting: null,
        chosenLocation: null,
        isChoosingLocation: false
      }
    case mainviewActions.ADD_SIGHTING_SUCCESS: 
      return {
        ...state,
        chosenLocation: null,
        isChoosingLocation: false,
        addedKoalaId: payload
      }
    case mainviewActions.EDIT_KOALA_SIGHTING_CANCEL:
      return {
        ...state,
        editedKoalaSighting: null,
        chosenLocation: null,
        isChoosingLocation: false
      }
    case mainviewActions.GET_USER_ACCOUNTS:
      return {
        ...state,
        userAccountListData: payload
      }
    case mainviewActions.REMOVE_USER_ACCOUNT_LIST:
      return {
        ...state,
        userAccountListData: null
      }
    case mainviewActions.EDIT_USER_ACCOUNT:
      return {
        ...state,
        editedUserAccount: payload
      }
    case mainviewActions.EDIT_USER_ACCOUNT_SUCCESS:
      return {
        ...state,
        editedUserAccount: null,
        userAccountListData: null
      }
    case mainviewActions.EDIT_USER_ACCOUNT_CANCEL:
      return {
        ...state,
        editedUserAccount: null
      }
    case mainviewActions.SELECT_LOCATION_ON_MAP:
      return {
        ...state,
        isChoosingLocation: true
      }
    case mainviewActions.SELECT_LOCATION_ON_MAP_COMPLETE:
      return {
        ...state,
        isChoosingLocation: false,
        chosenLocation: payload
      }
    case mainviewActions.SELECT_LOCATION_ON_MAP_CANCEL:
      return {
        ...state,
        isChoosingLocation: false,
        chosenLocation: null
      }
    case appActions.USER_LOG_OUT:
      return {
        ...state,
        userAccountListData: null,
        editedUserAccount: null,
        userKoalaSightingListData: null,
        editedKoalaSighting: null,
        showNVISHabitat: false,
        showKHAHabitat: false,
        showPreClearingHabitat: false,
        federalBoundaryPopupData: null,
        lgaBoundaryPopupData: null,
        stateBoundaryPopupData: null
      }
    default:
      return {
        ...state
      }
  }
  
}

export { reducer as mainviewReducer };
